export interface IPNSPasswordResetToken {
  token: string;
}
